module.exports = __webpack_public_path__ + "static/img/Adult-Human-Torso-A01-X-Ray2.fb216244.jpg";